// Logger service for environment-aware logging
class Logger {
  static isDevelopment = process.env.NODE_ENV === 'development';
  static isTest = process.env.NODE_ENV === 'test';
  
  // Log levels
  static levels = {
    ERROR: 0,
    WARN: 1, 
    INFO: 2,
    DEBUG: 3
  };

  // Current log level based on environment
  static currentLevel = Logger.isDevelopment ? Logger.levels.DEBUG : Logger.levels.ERROR;

  static log(level, message, ...args) {
    if (level <= this.currentLevel) {
      const timestamp = new Date().toISOString();
      const levelName = Object.keys(this.levels)[level];
      
      switch (level) {
        case this.levels.ERROR:
          console.error(`[${timestamp}] ERROR:`, message, ...args);
          break;
        case this.levels.WARN:
          console.warn(`[${timestamp}] WARN:`, message, ...args);
          break;
        case this.levels.INFO:
          console.info(`[${timestamp}] INFO:`, message, ...args);
          break;
        case this.levels.DEBUG:
          if (this.isDevelopment) {
            console.log(`[${timestamp}] DEBUG:`, message, ...args);
          }
          break;
        default:
          if (this.isDevelopment) {
            console.log(`[${timestamp}] LOG:`, message, ...args);
          }
      }
    }
  }

  static error(message, ...args) {
    this.log(this.levels.ERROR, message, ...args);
  }

  static warn(message, ...args) {
    this.log(this.levels.WARN, message, ...args);
  }

  static info(message, ...args) {
    this.log(this.levels.INFO, message, ...args);
  }

  static debug(message, ...args) {
    this.log(this.levels.DEBUG, message, ...args);
  }

  // Specific logging methods for different contexts
  static auth(message, ...args) {
    this.debug('AUTH:', message, ...args);
  }

  static api(message, ...args) {
    this.debug('API:', message, ...args);
  }

  static performance(message, ...args) {
    this.debug('PERFORMANCE:', message, ...args);
  }

  static ui(message, ...args) {
    this.debug('UI:', message, ...args);
  }
}

export default Logger;